// extracted by mini-css-extract-plugin
export default {"flag":"eSMhlw"};